<app-modal-header [hasClose]='true' [title]="title" (handleClose)="onDialogClose()"></app-modal-header>

<mat-dialog-content class="content-dialog">
  @if (!message) {
    <app-loading></app-loading>
  }

  @if (message) {
    <div class="mg1" style="text-align: left;">
      @if (message.message_pai) {
        <div class="preview-messages mgb1">
          <mat-expansion-panel #msg>
            <mat-expansion-panel-header>
              @if (msg.expanded) {
                <mat-panel-title class="bold-text preview-messages">
                  Mensagem Original
                </mat-panel-title>
              }
              @if (!msg.expanded) {
                <mat-panel-description [innerHtml]="message.message_pai.message">
                </mat-panel-description>
              }
            </mat-expansion-panel-header>
            <app-message [isParent]="true" [showSender]="showSender" [recipients]="recipients"
            [message]="message.message_pai" (openRecipientList)="viewRecipientList()"></app-message>
          </mat-expansion-panel>
        </div>
      }
      <div>
        <app-message [isParent]="false" [showSender]="showSender" [recipients]="recipients" [message]="message"
        (openRecipientList)="viewRecipientList()"></app-message>
      </div>
    </div>
  }

</mat-dialog-content>
